import * as React from 'react';
import { List, Edit, ShowButton, Show, SimpleShowLayout,Labeled,useRecordContext,Link, Datagrid, Button, TextField, DateField, Create, SimpleForm, TextInput, DateInput, required, EditButton, TopToolbar, BooleanInput, BooleanField } from 'react-admin';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { useParams } from 'react-router-dom';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const HvgPostCreate = () => (
    <Create redirect="list">
        <SimpleForm > 
            <Box sx={{ flexGrow: 1, width:'100%' }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextInput source="title" label="Title" sx={{width:'100%'}}  validate={[required()]} />
                    </Grid>
                    <Grid item xs={3}>
                        <BooleanInput label="Visible" source="visible" defaultValue={false}/>
                    </Grid>
                    <Grid item xs={6}>
                        <TextInput source="season" label="Saison" sx={{width:'100%'}}  validate={[required()]} />
                    </Grid>
                    <Grid item xs={6}>
                        <DateInput label="Publication" source="date" sx={{width:'100%'}} defaultValue={new Date()} />
                    </Grid>
                </Grid>
            </Box>
        </SimpleForm>
    </Create>
);
const HvgPostShowTitle = () => {
    const record = useRecordContext();
    return <span>{record ? `${record.title}` : ''}</span>;
};
export const HvgPostEdit = () => (
    <Edit title={<HvgPostShowTitle />}>
        <SimpleForm redirect="list">
                <Box sx={{ flexGrow: 1, width:'100%' }}>
                       <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextInput disabled label="Id" sx={{width:'100%'}} source="id" />
                            </Grid>
                            <Grid item xs={3}>
                                <BooleanInput label="visible" source="visible" />
                            </Grid>
                            <Grid item xs={6}>
                                <TextInput source="title" sx={{width:'100%'}} validate={required()} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextInput source="season" sx={{width:'100%'}} validate={required()} />
                            </Grid>
                            <Grid item xs={6}>
                                <DateInput label="Publication" sx={{width:'100%'}} source="date" />
                            </Grid>
                        </Grid>
                    </Box>
        </SimpleForm>
    </Edit>
);

export const HvgPostShow = () => (
    <Show title={<HvgPostShowTitle />} actions={<HvgEditionShowActions />}>
        <SimpleShowLayout>
              <Box sx={{ flexGrow: 1 }}>
                       <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Labeled label="Title">
                                        <TextField source="title" />
                                </Labeled>
                            </Grid>
                            <Grid item xs={6}>
                                <Labeled label="Visible">
                                    <BooleanField label="Visible" source="visible" />
                                </Labeled>
                            </Grid>
                            <Grid item xs={6}>
                                <Labeled label="Saison">
                                        <TextField source="season" />
                                </Labeled>
                            </Grid>
                            <Grid item xs={6}>
                                <Labeled label="Date">
                                     <DateField source="date" locales="fr-FR" label="Date" />
                                </Labeled>
                            </Grid>
                        </Grid>
                    </Box>
            </SimpleShowLayout>
    </Show>
);

/* const CreateChiliEditionButton = () => { 
    const { id } = useParams();
    return(
        <Button component={Link}
        to={`${process.env.REACT_APP_API_URL}/chilipublish/createEdition/${id}`} 
        target="_blank" 
        label="Synchroniser Chilipublish" /> 
    )
} */

const HvgEditionShowActions = () => (
    <TopToolbar>
        {/* <CreateChiliEditionButton/> */}
        <EditButton></EditButton>
    </TopToolbar>
);


const ModelListButton = () => {
    const editions = useRecordContext();
    return (
        <Button
            component={Link}
            to={`./${editions?.id}/models`}
            startIcon={<BusinessCenterIcon />}
            label='Models'
        >
            Models
        </Button>
    );
};

const ProjectListButton = () => {
    const editions = useRecordContext();
    return (
        <Button
            component={Link}
            to={`./${editions?.id}/projects`}
            startIcon={<CorporateFareIcon />}
            label='Projects'
        >
            Projects
        </Button>
    );
};

export const HvgPostList = () => (
    <List>
        <Datagrid>
            <TextField source="id"  label="ID"/>
            <TextField source="title" label="Title" />
            <BooleanField sx={{'text-align':'center'}}  TrueIcon={TaskAltIcon} FalseIcon={HighlightOffIcon} label="Visible" source="visible" />
            <TextField source="season" label="Saison" />
            <DateField source="date" label="Publication" />
            <EditButton />
            <ProjectListButton />
            <ShowButton />
        </Datagrid>
    </List>
);